import classNames from 'classnames';
import { t } from 'ttag';

import { Title } from '@ui/Title';
import { LocalizedLink } from '@ui/LocalizedLink';

import s from './PopularCatalogsRelinking.sss';

type City = {
  id: number
  name: string
};

type Link = {
  slug: string
  text: string
};

type PopularCatalogsRelinkingProps = {
  links: Link[]
  city?: City | null
  className?: string
};

export const PopularCatalogsRelinking: React.FC<PopularCatalogsRelinkingProps> = ({
  links,
  city,
  className,
}) => (
  <div className={classNames(s.root, className)}>
    <Title type="h5" bold={false}>{t`Популярні категорії товарів продавця:`}</Title>

    <div className={s.links}>
      {
        links.map(
          ({ text, slug }) => (
            <LocalizedLink
              key={slug}
              className={s.link}
              theme="clean"
              href={slug}
            >
              {
                city && city.id !== 2
                  ? `${text} в городе ${city.name}`
                  : text
              }
            </LocalizedLink>
          ),
        )
      }
    </div>
  </div>
);
